<template lang="pug">
  .b2b-page-add-services
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('new_project.title') }}
      ods-form(
        ref='projectDetailEditForm',
        :model='projectDetailEditForm',
        :rules='projectDetailEditFormRules',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='4')
            ods-form-item(
              :label='$t("new_project.new_project_form.name.label")',
              prop='name')
              ods-input(v-model='projectDetailEditForm.name')
          ods-col(:span='1')
          ods-col(:span='5')
            ods-form-item(
              :label='$t("new_project.new_project_form.code.label")',
              prop='code')
              ods-input(v-model='projectDetailEditForm.code')
          ods-col(:span='1')
            ods-tooltip(:content='$t("buttons.inicialize_tooltip")', placement='bottom')
              ods-button.refresh(
                type='primary',
                icon='ods-icon-refresh',
                size='medium',
                circle,
                @click='inicializecode')
          ods-col(:span='3')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("new_project.new_project_form.enable.label")',
              prop='enable')
              ods-select(
                :placeholder='$t("new_project.new_project_form.enable.placeholder")',
                v-model='projectDetailEditForm.enable')
                ods-option(
                  v-for='option in comboEnable',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("new_project.new_project_form.issuing.label")',
              prop='isSender')
              ods-select(
                :placeholder='$t("new_project.new_project_form.issuing.placeholder")',
                v-model='projectDetailEditForm.isSender')
                ods-option(
                  v-for='option in comboIsSender',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("new_project.new_project_form.reception.label")',
              prop='isReceiver')
              ods-select(
                :placeholder='$t("new_project.new_project_form.reception.placeholder")',
                v-model='projectDetailEditForm.isReceiver')
                ods-option(
                  v-for='option in comboIsReceiver',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item.logoItem(label='Logo', prop='logo', :tabIndex='-1')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native='showUploadDialog')
                | {{ $t('buttons.btnAdd') }}
              ods-form-item(:label="projectDetailEditForm.logo ? projectDetailEditForm.logo.name : ''" class='labelNameLogo', :tabIndex='-1')
                div
                  ods-button.logoButtons(
                    v-if='projectDetailEditForm.logo && projectDetailEditForm.logo.name.length > 0 ',
                    type='neutral',
                    @click='removeLogo')
                    ods-icon(name='close', size='24', class="botoneraLogo")
            ods-form-item(
                    v-if='canAdminIndra',
                    :label='$t("project_detail.facturar")',
                    prop='facturar')
                    ods-select(
                      v-model='projectDetailEditForm.facturar'
                      )
                      ods-option(
                        v-for='option in facturarOptions',
                        :key='option.value',
                        :label='option.value',
                        :value='option.value')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              v-if='canAdminIndra',
              :label='$t("new_project.new_project_form.indra_project.label")',
              prop='isIndraProject')
              ods-select(
                :placeholder='$t("new_project.new_project_form.indra_project.placeholder")',
                v-model='projectDetailEditForm.isIndraProject')
                ods-option(
                  v-for='option in comboIsIndraProject',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='large'
            @click='saveProject("projectDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}

    //- Dialogo Cargar logo
    ods-dialog(
      ref='dialogAddLogo',
      title='Carga un logo',
      :visible.sync='isShowDialogAddLogo',
      @close='handleCloseDialog'
      width='30%')
      ods-form(
        ref='formDialogAddLogo',
        :model='formDialogAddLogo',
        :rules='rulesDialogAddLogoForm')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddLogo.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormatsLogo.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}

      span.dialog-footer(slot='footer')
        ods-tooltip(:content='$t("project_detail.buttons.add_logo_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            @click.native='onSubmitAddLogo("formDialogAddLogo")')
            | {{ $t('project_detail.buttons.add_logo') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-add-services',
  mixins: [Utils],
  data () {
    const self = this
    const fillcodevalue = (rule, value, callback) => {
      if (self.projectDetailEditForm.name != null && !self.codeModified) {
        this.fillCode()
      }
      callback()
    }
    const checkcode = (rule, value, callback) => {
      const regex = RegExp(/^(AVZ|EDI|EDT|EDW|FNX|ITC|PTN|TGE|TPY|VAN|POC)-[0-9]{4}-[áéíóúÁÉÍÓÚa-zA-Z0-9_ ]{1,40}?$/) // eslint-disable-line
      if (value && !regex.test(value.toUpperCase())) {
        callback(new Error(this.$t('project_detail.validation.error_code', regex)))
      }
      callback()
    }
    const checkmodified = (rule, value, callback) => {
      console.log('valor del code ', value)
      if (value && value !== ('FNX-0000-' + self.projectDetailEditForm.name.toUpperCase())) {
        self.codeModified = true
      }
      callback()
    }
    const checkExtensionLogo = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (!this.validateExtensionLogo(this.formDialogAddLogo.fichero.name)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '. ' + this.$t('projects.error.wrongLogoExtension')))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    const checkFileSize = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (this.formDialogAddLogo.fichero && this.formDialogAddLogo.fichero.size > (100 * 1024)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('error.file_size.exceeded', { argumento: this.maxFileSize.toString() + ' KB' })))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }

    return {
      facturarOptions: [{ value: 'Editrack' }, { value: 'FacturaE' }],
      codeModified: false,
      projectDetailEditForm: {
        // Propiedades del proyecto
        name: null,
        code: null,
        enable: null,
        isSender: null,
        isReceiver: null,
        isIndraProject: null,
        logo: null,
        facturar: 'FacturaE'
      },

      // Combos
      comboEnable: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],
      comboIsSender: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],
      comboIsReceiver: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],
      comboIsIndraProject: [
        { value: true, label: this.$t('msg_generics.question.yes') }, { value: false, label: this.$t('msg_generics.question.no') }],

      // Logo
      isShowDialogAddLogo: false,
      maxFileSize: 100,
      extensionFormatsLogo: ['.jpg', '.jpeg', '.png'],
      formDialogAddLogo: {
        fichero: null
      },
      fileList: [],

      rulesDialogAddLogoForm: {
        fichero: [{
          required: true,
          message: this.$t('msg_generics.file_selected'),
          trigger: 'click'
        },
        { validator: checkExtensionLogo },
        { validator: checkFileSize }
        ]
      },

      // Validaciones
      projectDetailEditFormRules: {
        code: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'blur' },
          { validator: checkmodified, trigger: 'change' },
          { validator: checkcode, trigger: 'change' }
        ],
        name: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'click' },
          { max: 40, message: this.$t('msg_generics.max_num_character', { max: 40 }), trigger: 'change' },
          { validator: fillcodevalue, trigger: 'change' }
        ],
        enable: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        isSender: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],

        isReceiver: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],

        isIndraProject: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'canAdminIndra'
    ])
  },

  methods: {
    ...mapActions([
      'createProject'
    ]),

    // Reseteo al cerrar dialogo de añadir logo
    handleCloseDialog () {
      this.$refs.formDialogAddLogo.resetFields()
      this.fileList = []
    },

    validateExtensionLogo (filename) {
      return this.extensionFormatsLogo.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    // Acciones del logo
    onSubmitAddLogo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('new_project.load.upload_logo')
          })

          console.log('submit!!!   ', this.fileList)
          this.projectDetailEditForm.logo = this.fileList[0]
          console.log('this.projectDetailEditForm.logo!!!   ', this.projectDetailEditForm.logo)
          this.isShowDialogAddLogo = false
          this.$notify({
            title: this.$t('new_project.notify.upload_logo'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          load.close()
          return true
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddLogo.fichero = file
      this.$refs.formDialogAddLogo.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    /* Autorrellena el código en función del nombre */
    fillCode () {
      this.projectDetailEditForm.code = 'FNX-0000-' + this.projectDetailEditForm.name.toUpperCase()
    },
    inicializecode () {
      this.projectDetailEditForm.code = 'FNX-0000-' + this.projectDetailEditForm.name.toUpperCase()
      this.codeModified = false
    },

    showUploadDialog (event) {
      this.isShowDialogAddLogo = true
      if (event) event.preventDefault()
    },

    selectFile (event) {
      if (event) event.preventDefault()
    },

    /* *Guarda los cambios del proyecto  */
    async saveProject (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          console.log('saveProject: ', this.projectDetailEditForm)
          const load = this.$loading({
            lock: true,
            text: this.$t('new_project.load.save_changes')
          })
          try {
            await this.createProject({
              // Logo
              logo: this.projectDetailEditForm.logo,
              // Datos
              projectData: {
                name: this.projectDetailEditForm.name,
                code: this.projectDetailEditForm.code.toUpperCase(),
                enable: this.projectDetailEditForm.enable,
                isSender: this.projectDetailEditForm.isSender,
                isReceiver: this.projectDetailEditForm.isReceiver,
                isIndraProject: this.projectDetailEditForm.isIndraProject,
                facturar: this.projectDetailEditForm.facturar
              }
            })
            this.$notify({
              title: this.$t('new_project.notify.save_changes'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })

            // - Reseteamos
            this.$refs.projectDetailEditForm.clearValidate()
            this.$refs.projectDetailEditForm.resetFields()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('submitServiceDetailEditForm: ', this.projectDetailEditForm)
        }
      })
    },
    //* *Elimina el logo del proyecto */
    removeLogo () {
      console.log('removeLogo...')
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_logo')
      })
      try {
        this.projectDetailEditForm.logo = null
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-add-services {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 110px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
  .botoneraLogo {
    padding-bottom: rem(0) !important;
    margin-left: rem(0);
  }
  .labelNameLogo {
    margin-top: 20px;
    vertical-align: middle;
    text-transform: initial !important;
    padding-bottom: rem(0) !important;
    margin-left: rem(10);
    display: inline-flex;
  }
  .ods-button.logoButtons {
    padding: 2px;
  }
  .ods-button + .ods-button {
    margin-left: rem(0) !important;
  }
  .ods-button.refresh {
    margin-left: 10px;
    margin-top: 18px;
  }
}
</style>
